import { Component, Input, Output, EventEmitter, TemplateRef, ViewChild, OnInit } from '@angular/core';
import { formatCurrency } from '@angular/common';

import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap/modal';
import { NgbCarouselConfig, NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Router } from '@angular/router';

import { BaseService } from 'app/_services/base.service';
import { BuyerDadosPedidoService } from './dados-pedido.service';
import { BuyerSemaforoCuradorService } from '../../semaforo-curador/semaforo.service';
import { BuyerService } from '../../_services/buyer.service';
import { GeneralService } from 'app/_services/general.service';
import { ImageDisplayService } from 'app/_componentes/image-display/image-display.service';
import { NotificationService } from 'app/_services/notification.service';
import { SellerOrderService } from 'app/seller/_services/order.service';
import { SellerDashboardService } from 'app/seller/dashboard/dashboard.service';
import { SettingsService } from 'app/_services/settings.service';

import { AddComplementDataModel } from '../adicionar-complemento/_models/addComplementDataModel';
import { ApiResponseModel } from 'app/_models/apiResponseModel';
import { BuyerDashboardGetRejectOrderReasons } from 'app/buyer/_models/buyerDashboardGetRejectedOrderReasons';
import { BuyerOrdersPatchUpdateStatusItensResponseModel } from '../../_models/buyerOrdersPatchUpdateStatusItensResponseModel';
import { CancelReasonRelatedId, CancelReasons } from 'app/_models/cancelReasons';
import { EditionTypeEnum } from './_models/editionTypeEnum';
import { Globals } from 'app/_models/globals';
import { NotaFiscal, PedidoNotaFiscal } from 'app/_componentes/notafiscal/_models/pedidonotafiscal';
import { StatusIdEnum, isAwaitingConfirmationAfterDelivered, isFinalStatus, isOldStatusConfirmado } from 'app/_models/statusId';
import { SweetAlertParams } from 'app/_models/notificationParams.model';
import { Transportadora } from 'app/_models/transportadora';
import { WhatsAppMessage } from 'app/_models/whatsAppMessage';
import { UserService } from 'app/_services/user.service';
import { BroadCastEventEnum } from 'app/_models/_enums/broadCastEvent.enum';

declare const $: any;
declare const copyToClipboard: any;
declare const getDate: any;
declare const getJavascriptDateFromIsoDate: any;
declare const isEmpty: any;
declare const isValidDate: any;
declare const setDateNextWorkingDay: any;
declare const waitForElm: any;

@Component({
    selector: 'app-dados-pedido', templateUrl: './dados-pedido.component.html', styleUrls: ['./dados-pedido.component.scss'],
    standalone: false
})
export class BuyerDadosPedidoComponent implements OnInit {
    @Input() get agrupamento(): any {
        return this._agrupamento;
    }
    set agrupamento(value: any) {
        if (!isEmpty(value)) {
            value.pedidos.forEach(pedido => { this.setSelectAll(pedido) });
        }
        this._agrupamento = value;
    }

    @Input() deliveryTimes: any[];
    @Input() feriados: string[];
    @Input() formasPagamento?: string[];
    @Input() transportadoras: Transportadora[] = [];
    @Input() voltarHome: boolean;
    @Input() esconderRefresh: boolean;
    @Output() atualizarPedido = new EventEmitter();
    @Output() copyGetConfirmation = new EventEmitter();
    @ViewChild('templateObservacoes') templateObservacoes: TemplateRef<any>;
    @ViewChild('templateCancelarEntrega') templateCancelarEntrega: TemplateRef<any>;
    modalRef: BsModalRef;

    private _agrupamento: any;
    private max_days_delivery: number = 40;

    calendarMaxDate: any;
    calendarMinDate: any;
    calendarMarkDisabled: any;
    cotacaoSelecionada: any;
    pedidoSelecionado: any;
    hasAguardandoConfirmacao: boolean = false;
    isMercadoPartsfy: boolean;
    modal_visivel: { adicionar_complemento: boolean, comentarios: boolean };
    origem_tipo: string;

    selectedOrder: any;
    cancelReasons: CancelReasons[] = [];
    excluirCotacaoNeedsComment: boolean = false;

    itemCurrentlyEditing: any;

    get StatusIdEnum(): typeof StatusIdEnum {
        return StatusIdEnum;
    }

    constructor(public userService: UserService, private baseService: BaseService, public buyerService: BuyerService, private curadorService: BuyerSemaforoCuradorService, private dashboardService: SellerDashboardService,
        private dadosPedidoService: BuyerDadosPedidoService, private imageDisplayService: ImageDisplayService, private generalService: GeneralService, private notificationService: NotificationService, public settingService: SettingsService,
        private orderService: SellerOrderService, private globals: Globals, private modalService: BsModalService, private calendar: NgbCalendar, private carouselConfig: NgbCarouselConfig, private ngxLoader: NgxUiLoaderService, private router: Router)
    {
        this.origem_tipo = window.location.href.toString().includes('gestor-comprador') ? 'gestor-comprador' : (window.location.href.toString().includes('supervisor-comprador') ? 'supervisor-comprador' : 'comprador');

        this.cotacaoSelecionada = { veiculo: null };
        this.carouselConfig.interval = 200000;

        // Verifica se precisa adicionar complemento em algum pedido ou editar alguma peça
        if (this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras.state) {
            const currentState = this.router.getCurrentNavigation().extras.state;

            if (currentState.adicionar_complemento && currentState.quotation_id) {
                waitForElm(`.adicionar-complemento.id_${currentState.quotation_id}`).then((elm) => {
                    let $btnAdicionarComplemento = $(`.adicionar-complemento.id_${currentState.quotation_id}`);
                    $btnAdicionarComplemento.trigger('click');
                });
            }
        }

        this.baseService.broadCastChannel.onmessage = (event) => {
            if (event.tipo === BroadCastEventEnum.FecharGuiaEvent) {
                close()
            }
        }
    }

    ngOnInit() {
        this.modal_visivel = { adicionar_complemento: false, comentarios: false };

        this.ngxLoader.startLoader('loader-principal');

        this.generalService.getDeliveryDateByWorkingDays(this.max_days_delivery).subscribe({
            next: (response: ApiResponseModel<{deliveryDate: any}>) => {
                let hoje = new Date();
                let maxDate = new Date(response.result.deliveryDate);
                this.calendarMinDate = { year: hoje.getFullYear(), month: hoje.getMonth() + 1, day: hoje.getDate() };
                this.calendarMaxDate = { year: maxDate.getFullYear(), month: maxDate.getMonth() + 1, day: maxDate.getDate() };
                this.calendarMarkDisabled = (date: NgbDate) => this.buyerService.disableCalendarOnWeekendsAndHolidays(date, this.calendar, this.feriados);

                this.ngxLoader.stopLoader('loader-principal');
            },
            error: error => {
                console.log(error);
                this.ngxLoader.stopLoader('loader-principal');
            }
        });
    }


    adicionar_complemento_modal_abrir($event, transaction_id: number, quotation_id: number, order_id: number, veiculo, pedido) {
        $event.stopPropagation();

        let pecas = pedido.pecas;

        this.cotacaoSelecionada = {
            transaction_id: transaction_id,
            quotation_id: quotation_id,
            order_id: order_id,
            answer_in_id: pedido.answer_in_id,
            veiculo: veiculo,
            selected_payment_type: pedido.selected_payment_type,
            original_selected_payment_type: pedido.original_selected_payment_type,
            chosen_date: getJavascriptDateFromIsoDate(pecas[0].chosen_date),
            confirmation_date: getJavascriptDateFromIsoDate(pecas[0].confirmation_date)
        } as AddComplementDataModel;

        this.modal_visivel.adicionar_complemento = true;
    }

    adicionar_complemento_modal_fechar($event) {
        this.modal_visivel.adicionar_complemento = false;

        setTimeout(() =>
        {
            if ($event.atualizar)
            {
                this.atualizar($event.transaction_id);
            }
        }, 200);
    }

    atualizar(transaction_id) {
        this.atualizarPedido.emit({ quotation_id: transaction_id });
    }

    buttonIsEnableCancel(itens) { return itens.some(i => i.is_selected); }

    buttonIsEnableConfirmation(itens) { return itens.some(i => (i.is_selected && isOldStatusConfirmado(i.status))) && !itens.some(i => (i.is_selected && !isOldStatusConfirmado(i.status))); }

    buttonIsEnableEdit(itens) { return itens.some(i => !isFinalStatus(i.status)); }

    buttonIsVisible(itens, pedido = null) {
        for (let i = 0; i < itens.length; i++) {
            const status_id = itens[i].status;

            if ((status_id === StatusIdEnum.Pedido || status_id === StatusIdEnum.EmAnalise || isOldStatusConfirmado(status_id))) {
                if ((pedido != null && (!pedido.is_external_answer || isOldStatusConfirmado(status_id))))
                    return false;

                return true;
            }
        }

        return false;
    }

    buttonIsVisibleConfirmado(itens)
    {
        for (let i = 0; i < itens.length; i++)
        {
            if (isOldStatusConfirmado(itens[i].status))
                return true;
        }

        return false;
    }

    cancelarEntrega(reopen: boolean = false) {
        if (this.selectedOrder == null)
            return;

        var item_ids = this.selectedOrder.pecas.filter(i => { return i.is_selected && (!isFinalStatus(i.status_id) || !isFinalStatus(i.status)) }).map(i => i.item_id);

        if (this.isMercadoPartsfy) {
            this.cancelarEntregaExecutar(this.selectedOrder, this.selectedOrder.order_id, item_ids, false, true);
        } else {
            this.cancelarEntregaExecutar(this.selectedOrder, this.selectedOrder.order_id, item_ids, reopen);
        }
    }

    cancelarEntregaChangeValue() {
        var needsComment = $('select[name="reason"]').find(':selected').attr('needs-comment') == 'true';
        $('textarea[name="comment"]').val('');

        this.excluirCotacaoNeedsComment = needsComment;
    }

    private async cancelarEntregaExecutar(pedido, order_id, item_ids, reopen, redirectToMercadoPartsfy = false)
    {
        var reason_id = parseInt($('select[name="reason"]').val());
        var comment = $('textarea[name="comment"]').val();

        if($('select[name="reason"]').val() == null) {
            await this.notificationService.showWarning('buyer.dados-pedido.mensagens.cancelar-entrega.erro.falta-motivo.corpo', 'buyer.dados-pedido.mensagens.cancelar-entrega.erro.falta-motivo.titulo');
            return;
        }

        if (this.excluirCotacaoNeedsComment && isEmpty(comment.trim())) {
            await this.notificationService.showWarning('buyer.dados-pedido.mensagens.cancelar-entrega.erro.falta-comentario.corpo', 'buyer.dados-pedido.mensagens.cancelar-entrega.erro.falta-comentario.titulo');
            return;
        }

        this.ngxLoader.startLoader('loader-cancelar-entrega');
        this.dadosPedidoService.setPartsAsRejected(order_id, reopen, item_ids, reason_id, comment).subscribe({
            next: () => {
                this.ngxLoader.stopLoader('loader-cancelar-entrega');
                this.notificationService.showSuccessToastr(this.globals.translate('buyer.dados-pedido.mensagens.cancelar-entrega.sucesso.corpo'));

                this.atualizarPedido.emit({ quotation_id: pedido.transaction_id });

                this.modal_fechar()

                if(redirectToMercadoPartsfy) {
                    this.router.navigate(['/comprador/mercado']);
                }
            },
            error: () => {
                this.notificationService.showErrorToastr(this.globals.translate('buyer.dados-pedido.mensagens.cancelar-entrega.erro.desconhecido.corpo'));
                this.ngxLoader.stopLoader('loader-cancelar-entrega');
            }
        });
    }

    checkVazio(obj)
    {
        return isEmpty(obj);
    }

    confirmarEntrega(order_id: number) {
        let pedidos = this.agrupamento.pedidos.filter((q) => { return q.order_id === order_id });

        if (pedidos.length < 1)
            return;

        var pedido = pedidos[0];

        var itemIds = pedido.pecas.filter(i => { return i.is_selected && (!isFinalStatus(i.status_id) || !isFinalStatus(i.status)) }).map(i => i.item_id);

        const params: SweetAlertParams = {
            title: 'buyer.dados-pedido.confirmar-entrega.titulo',
            message: 'buyer.dados-pedido.confirmar-entrega.corpo',
            icon: 'warning',
            confirmButtonText: 'buyer.dados-pedido.confirmar-entrega.botoes.sim',
            cancelButtonText: 'buyer.dados-pedido.confirmar-entrega.botoes.nao'
        }

        this.notificationService.showConfirm(params).then((result) => {
            if (result.value) {
                this.ngxLoader.startLoader('loader-principal');
                this.dadosPedidoService.setPartsAsDelivered(order_id, itemIds).subscribe({
                    next: async (response: ApiResponseModel<BuyerOrdersPatchUpdateStatusItensResponseModel>) => {
                        if (response != null) {
                            this.notificationService.showSuccessToastr(this.globals.translate('buyer.dados-pedido.mensagens.confirmar-entrega.sucesso.corpo'));

                            if (response.result.cashbackValue) {
                                var corpo = this.globals.translate('buyer.dados-pedido.mensagens.confirmar-entrega.cashback.corpo-parte-1') + (response.result.cashbackValue, this.globals.translate("outros.currency")) + this.globals.translate('buyer.dados-pedido.mensagens.confirmar-entrega.cashback.corpo-parte-2');
                                await this.notificationService.showWarning(corpo, 'buyer.dados-pedido.mensagens.confirmar-entrega.cashback.titulo', false, true);
                            }

                            this.atualizarPedido.emit({ quotation_id: pedido.transaction_id });
                        }

                        this.ngxLoader.stopLoader('loader-principal');
                    },
                    error: error => {
                        console.log(error);
                        this.ngxLoader.stopLoader('loader-principal');
                    }
                });
            }
        })
    }

    confirmarPedido(pedido) {
        if (pedido.selected_payment_type === 0) {
            const params: SweetAlertParams = {
                bigSwall: true,
                icon: 'warning',
                title: 'seller.dashboard.detalhes.mensagens.confirm.confirmar-pedido-a-vista.titulo',
                input: 'select',
                inputOptions: this.formasPagamento,
                inputPlaceholder: 'seller.dashboard.detalhes.mensagens.confirm.confirmar-pedido-a-vista.placeholder',
                inputValidator: (value) => {
                    return new Promise((resolve) => {
                        if (!isEmpty(value))
                            resolve('');
                        else
                            resolve(this.globals.translate('seller.dashboard.detalhes.mensagens.confirm.confirmar-pedido-a-vista.erro'));
                    })
                },
                showDenyButton: true,
                cancelButtonText: 'elemento.generico-botao.cancelar',
                confirmButtonText: 'seller.dashboard.detalhes.botao.confirmar-pedido-a-vista.faturar',
                denyButtonText: 'seller.dashboard.detalhes.botao.confirmar-pedido-a-vista.manter',
                customClass: { cancelButton: 'order-1', confirmButton: 'order-3', denyButton: 'order-2' }
            }

            this.notificationService.showConfirm(params).then((result) => {
                if (result.isDismissed)
                    return;

                const new_payment_type_id = result.isDenied ? null : result.value;
                this.confirmarPedidoExecucao(new_payment_type_id, pedido);
            });

            return;
        } else {
            const params: SweetAlertParams = {
                bigSwall: true,
                icon: 'warning',
                message: 'buyer.dados-pedido.mensagens.confirmar-pedido.corpo',
                title: 'buyer.dados-pedido.mensagens.confirmar-pedido.titulo',
                cancelButtonText: 'elemento.generico-select.nao',
                confirmButtonText: 'elemento.generico-select.sim'
            }

            this.notificationService.showConfirm(params).then((result) => {
                if (result.isDismissed)
                    return;

                this.confirmarPedidoExecucao(null, pedido);
            });
        }
    }

    confirmarPedidoExecucao(new_payment_type_id, pedido, nAttempts: number = 0) {
        this.ngxLoader.startLoader('loader-principal');

        this.orderService.setAsAwaitingForDelivery(pedido.order_id, new_payment_type_id)
            .subscribe(
                () =>
                {
                    this.notificationService.showSuccessToastr(this.globals.translate('seller.dashboard.detalhes.mensagens.sucesso.confirmar-pedido.corpo'));

                    this.atualizarPedido.emit({ quotation_id: pedido.transaction_id });

                    this.ngxLoader.stopLoader('loader-principal');
                },
                error =>
                {
                    if (error.status === 404)
                    {
                        return;
                    }

                    nAttempts = nAttempts || 1;
                    console.log(error, nAttempts);

                    if (nAttempts >= 5)
                    {
                        this.ngxLoader.stopLoader('loader-principal');
                        this.notificationService.showErrorToastr(this.globals.translate('seller.dashboard.detalhes.mensagens.erro.confirmar-pedido.corpo'));
                        return;
                    }

                    this.confirmarPedidoExecucao(new_payment_type_id, pedido, ++nAttempts);
                });
    }

    copiarClipboardConfirmation(orderId: number) {
        this.copyGetConfirmation.emit({ orderId });
    }

    copiarClipboardObservacoes(pedido) {
        let texto = pedido.seller_notes;

        if (isEmpty(texto))
            return;

        texto = texto.trim();
        copyToClipboard(texto);
    }

    editDateChanged($event, peca) {
        this.buyerService.handleEditDateChanged($event, peca, this.feriados)
    }

    editarResposta_AtualizarFrete(frete)
    {
        frete.was_changed = true;

        if (frete.conta_comprador || frete.valor <= 0 || isEmpty(frete.valor))
            frete.valor = 0;
    }

    editarResposta_Cancelar(resposta) {
        if(!isEmpty(this.itemCurrentlyEditing)) {
            this.itemCurrentlyEditing.editDate = false;
            this.itemCurrentlyEditing.editValueSection = false;
            this.itemCurrentlyEditing = null;
        }

        resposta.editFrete = false;
        resposta.isOnEditMode = false;
        resposta.editionType = null;
    }

    editarResposta_FormatarFrete(frete)
    {
        if (isEmpty(frete.shipping_cost) || frete.shipping_cost === 0)
        {
            if (frete.buyer_responsability)
                return this.globals.translate('buyer.cotacao.area-respostas.resposta.editar.frete.conta-comprador');
            else
                return this.globals.translate('buyer.cotacao.area-respostas.resposta.editar.frete.gratuito');
        }

        return formatCurrency(frete.shipping_cost, 'pt-BR', 'R$', 'BRL');
    }

    editarResposta_Salvar(pedido: any) {
        switch(pedido.editionType as EditionTypeEnum) {
            case EditionTypeEnum.DeliveryDate: {
                this.editarDataEntrega_Salvar(pedido, 0)
                break;
            }
            case EditionTypeEnum.Frete: {
                this.editarFrete_Salvar(pedido, 0)
                break;
            }
            case EditionTypeEnum.Values: {
                this.editarValores_Salvar(pedido, 0)
                break;
            }
        }
    }

    async editarDataEntrega_Salvar(pedido: any, nAttempts: number) {
        let deliveryDate = null;
        let isBO = this.itemCurrentlyEditing.editIsBO;
        let isPF = this.itemCurrentlyEditing.editIsPF;

        let itemsId: Number[] = [];
        let pecasNaoEntregues = pedido.pecas.filter(peca => !isFinalStatus(peca.status))

        const params: SweetAlertParams = {
            cancelButtonText: 'buyer.dados-pedido.mensagens.alterar.data-entrega-alinhar.nao',
            confirmButtonText: 'buyer.dados-pedido.mensagens.alterar.data-entrega-alinhar.sim',
            icon: 'question',
            title: 'buyer.dados-pedido.mensagens.alterar.data-entrega-alinhar.titulo'
        }

        let shouldAlignDeliveryDates = pecasNaoEntregues.length > 1 && (await this.notificationService.showConfirm(params)).isConfirmed;
        let items = shouldAlignDeliveryDates ? pecasNaoEntregues : [this.itemCurrentlyEditing]

        var confirmationDate = this.itemCurrentlyEditing.status <= StatusIdEnum.EmAnalise ? new Date() : getJavascriptDateFromIsoDate(this.itemCurrentlyEditing.confirmation_date);

        // Se a data de confirmação for após as 18h, coloca na manhã do próximo dia útil
        if (confirmationDate.getHours() > 18)
            confirmationDate = setDateNextWorkingDay(confirmationDate, this.feriados);

        if(!isBO && this.itemCurrentlyEditing.status != StatusIdEnum.AguardandoConfirmacaoTroca && this.itemCurrentlyEditing.status != StatusIdEnum.AguardandoConfirmacaoDevolucao) {
            if (this.itemCurrentlyEditing.data_entrega == '') {
                let corpo = this.globals.translate('buyer.dados-pedido.mensagens.alterar.erro.dados-invalidos.corpo.invalid-date');
                await this.notificationService.showWarning(corpo.replace('{0}', this.itemCurrentlyEditing.peca), 'buyer.cotacao.mensagens.alterar.erro.dados-invalidos.titulo', false, true);
                return;
            }

            deliveryDate = this.itemCurrentlyEditing.newDataEntrega;

            if (!isValidDate(deliveryDate) && !deliveryDate.hasOwnProperty('year')) {
                const nDate = getDate(deliveryDate);
                deliveryDate = { year: nDate.getFullYear(), month: nDate.getMonth() + 1, day: nDate.getDate() };
            }

            deliveryDate = new Date(deliveryDate.year, deliveryDate.month - 1, deliveryDate.day, 8);
        }

        // Monta os dados de retorno
        itemsId = items.map(item => item.item_id);

        // Fecha o modo de edição
        this.ngxLoader.startLoader('loader-principal');
        this.editarResposta_Cancelar(pedido);

        this.dadosPedidoService.changeOrderDeliveryDate(pedido.order_id, confirmationDate, isBO, isPF, itemsId, deliveryDate).subscribe({
            next: (response: ApiResponseModel<boolean>) => {
                if (response && response.success && response.result) {
                    this.notificationService.showSuccessToastr(this.globals.translate('buyer.dados-pedido.mensagens.alterar.sucesso.salvar.corpo'));
                    this.atualizar(pedido.transaction_id);
                } else {
                    this.notificationService.showErrorToastr(this.globals.translate('buyer.dados-pedido.mensagens.alterar.erro.salvar.corpo'));
                    this.ngxLoader.stopLoader('loader-principal');
                }
            },
            error: error => {
                nAttempts = nAttempts || 1;
                console.log(error, nAttempts);

                if (nAttempts >= 5) {
                    this.atualizar(pedido.transaction_id);
                    this.notificationService.showErrorToastr(this.globals.translate('buyer.dados-pedido.mensagens.alterar.erro.salvar.corpo'));
                    return;
                }

                this.ngxLoader.stopLoader('loader-principal');
                this.editarDataEntrega_Salvar(pedido, ++nAttempts);
            }
        })
    }

    async editarFrete_Salvar(pedido: any, nAttempts: number) {
        // Atualiza a resposta com as novas informações de frete
        let frete = { answer_in_id: pedido.answer_in_id, shipping_cost: ((pedido.newFrete.tipo === '1' || pedido.newFrete.conta_comprador) ? null : pedido.newFrete.valor), buyer_responsability: (pedido.newFrete.tipo === '1' ? false : pedido.newFrete.conta_comprador), was_changed: pedido.was_changed || pedido.newFrete.was_changed };
        let valor_frete = (isEmpty(frete.shipping_cost) || frete.buyer_responsability) ? 0 : frete.shipping_cost;

        if (!frete.buyer_responsability && pedido.newFrete.tipo === '2' && valor_frete == 0) {
            await this.notificationService.showWarning('buyer.cotacao.mensagens.alterar.erro.dados-invalidos.corpo.frete-zerado', 'buyer.cotacao.mensagens.alterar.erro.dados-invalidos.titulo');
            return;
        }

        if (pedido.newFrete.was_changed) {
            pedido.frete_valor = valor_frete;
            pedido.frete_formatado = this.editarResposta_FormatarFrete(frete);
            pedido.buyer_responsability = frete.buyer_responsability;
            pedido.was_changed = true;
        }

        // Fecha o modo de edição
        this.ngxLoader.startLoader('loader-principal');
        this.editarResposta_Cancelar(pedido);

        this.dadosPedidoService.changeOrderFrete(pedido.order_id, frete).subscribe({
            next: (response: ApiResponseModel<boolean>) => {
                if (response && response.success && response.result) {
                    this.notificationService.showSuccessToastr(this.globals.translate('buyer.dados-pedido.mensagens.alterar.sucesso.salvar.corpo'));
                    this.atualizar(pedido.transaction_id);
                } else {
                    this.notificationService.showErrorToastr(this.globals.translate('buyer.dados-pedido.mensagens.alterar.erro.salvar.corpo'));
                    this.ngxLoader.stopLoader('loader-principal');
                }
            },
            error: error => {
                nAttempts = nAttempts || 1;
                console.log(error, nAttempts);

                if (nAttempts >= 5) {
                    this.atualizar(pedido.transaction_id);
                    this.notificationService.showErrorToastr(this.globals.translate('buyer.dados-pedido.mensagens.alterar.erro.salvar.corpo'));
                    return;
                }

                this.ngxLoader.stopLoader('loader-principal');
                this.editarFrete_Salvar(pedido, ++nAttempts);
            }
        })
    }

    async editarValores_Salvar(pedido: any, nAttempts: number) {
        let item = this.itemCurrentlyEditing;

        // Realiza a validação
        if (item.newQuantidade <= 0 || item.newQuantidade > 999) {
            await this.notificationService.showWarning('buyer.dados-pedido.mensagens.alterar.erro.dados-invalidos.corpo.quantity', 'buyer.cotacao.mensagens.alterar.erro.dados-invalidos.titulo');
            return;
        }

        if (item.newValorUnitario <= 0) {
            let corpo = this.globals.translate('buyer.dados-pedido.mensagens.alterar.erro.dados-invalidos.corpo.price');
            await this.notificationService.showWarning(corpo.replace('{0}', item.peca), 'buyer.cotacao.mensagens.alterar.erro.dados-invalidos.titulo', false, true);
            return;
        }

        var sellerHasCashback = pedido.seller_has_cashback;

        if(pedido.isCashbackCustomizado) {
            if(!(await this.notificationService.showConfirmationDialog(item.newDesconto < item.desconto_original ? 'buyer.dados-pedido.mensagens.alterar.desconto.cashback-customizado.alterar' : 'buyer.dados-pedido.mensagens.alterar.desconto.cashback-customizado.remover')))
                return

            item.desconto_original =  item.newDesconto >= item.desconto_original ? item.newDesconto : item.desconto_original;
        } else if (pedido.isCashbackPadronizado) {
            const params: SweetAlertParams = {
                title: 'buyer.dados-pedido.mensagens.alterar.desconto.cashback-padronizado.titulo',
                icon: 'question',
                cancelButtonText: 'buyer.dados-pedido.mensagens.alterar.desconto.cashback-padronizado.cancelar',
                confirmButtonText: 'buyer.dados-pedido.mensagens.alterar.desconto.cashback-padronizado.sim',
                denyButtonText: 'buyer.dados-pedido.mensagens.alterar.desconto.cashback-padronizado.nao',
                showDenyButton: true
            }

            let confirmCustomCashback = false;

            if (sellerHasCashback && item.newDesconto < item.desconto_original) {
                const confirmResult = (await this.notificationService.showConfirm(params));

                if (confirmResult.isDismissed) {
                    this.editarResposta_Cancelar(pedido);
                    return;
                }

                confirmCustomCashback = confirmResult.isConfirmed;
            }

            item.desconto_original =  confirmCustomCashback ? item.desconto_original : item.newDesconto;
        } else {
            const params: SweetAlertParams = {
                title: 'buyer.dados-pedido.mensagens.alterar.desconto.sem-cashback.titulo',
                icon: 'question',
                confirmButtonText: 'buyer.dados-pedido.mensagens.alterar.desconto.sem-cashback.sim',
                cancelButtonText: 'buyer.dados-pedido.mensagens.alterar.desconto.sem-cashback.nao'
            }

            let confirmCustomCashback = sellerHasCashback && item.newDesconto < item.desconto_original && (await this.notificationService.showConfirm(params)).isConfirmed;
            item.desconto_original =  confirmCustomCashback ? item.desconto_original : item.newDesconto;
        }

        item.quantidade = item.quantity = isEmpty(item.newQuantidade) || item.newQuantidade < 1 ? 1 : item.newQuantidade;
        item.desconto = item.newDesconto;
        item.valor_unitario = item.newValorUnitario;

        // Fecha o modo de edição
        this.ngxLoader.startLoader('loader-principal');
        this.editarResposta_Cancelar(pedido);

        this.dadosPedidoService.changeOrderValues(pedido.order_id, item.item_id, item.quantidade, item.desconto, item.desconto_original, item.valor_unitario).subscribe({
            next: (response: ApiResponseModel<boolean>) => {
                if (response && response.success && response.result) {
                    this.notificationService.showSuccessToastr(this.globals.translate('buyer.dados-pedido.mensagens.alterar.sucesso.salvar.corpo'));
                    this.atualizar(pedido.transaction_id);
                } else {
                    this.notificationService.showErrorToastr(this.globals.translate('buyer.dados-pedido.mensagens.alterar.erro.salvar.corpo'));
                    this.ngxLoader.stopLoader('loader-principal');
                }
            },
            error: error => {
                nAttempts = nAttempts || 1;
                console.log(error, nAttempts);

                if (nAttempts >= 5) {
                    this.atualizar(pedido.transaction_id);
                    this.notificationService.showErrorToastr(this.globals.translate('buyer.dados-pedido.mensagens.alterar.erro.salvar.corpo'));
                    return;
                }

                this.ngxLoader.stopLoader('loader-principal');
                this.editarValores_Salvar(pedido, ++nAttempts);
            }
        })
    }

    excluirNota($event, pedido)
    {
        let atualizar = this.atualizar;
        let transactionId = pedido.transaction_id;

        let indice = pedido.notasFiscais.findIndex(n => n.url === $event.nota_url);
        pedido.notasFiscais.splice(indice, 1);

        if(pedido.notasFiscais.length == 0) {
            if(this.cotacaoSelecionada.fotos.length > 0)
                this.cotacaoSelecionada.active = 1;
            else if(this.cotacaoSelecionada.seller_notes || this.cotacaoSelecionada.buyer_notes) {
                this.cotacaoSelecionada.active = 3;
            } else {
                this.modal_fechar()
            }
        }

        this.dashboardService.excluirNF($event.nota_url, pedido, function () { atualizar(transactionId); });
    }

    getRejectOrderReasons(nAttempts: number) {
        this.ngxLoader.startLoader('loader-principal');

        this.dadosPedidoService.getRejectOrderReasons(CancelReasonRelatedId.PecaRejeitadaPeloComprador).subscribe({
            next: (response: any) => {
                this.cancelReasons = response.result.cancelReasons;
                this.ngxLoader.stopLoader('loader-principal');
            },
            error: error =>
            {
                if (error.status === 404)
                {
                    this.notificationService.showErrorToastr(this.globals.translate('buyer.dados-pedido.mensagens.erro.carregamento.corpo'));
                    return;
                }

                nAttempts = nAttempts || 1;
                console.log(error, nAttempts);

                if (nAttempts >= 5)
                {
                    this.ngxLoader.stopLoader('loader-principal');
                    this.notificationService.showErrorToastr(this.globals.translate('buyer.dados-pedido.mensagens.erro.carregamento.corpo'));
                    return;
                }

                this.getRejectOrderReasons(++nAttempts);
            }
        })
    }

    goToCompararCondicoes(transaction_id)
    {
        this.router.navigate(['/' + this.origem_tipo + '/visao-geral/pedido/' + transaction_id + '/condicoes']);
    }

    isAwaitingConfirmationInternal(status_id) { return isAwaitingConfirmationAfterDelivered(status_id); }
    isFinalStatusInternal(status_id) { return isFinalStatus(status_id); }

    lockFiled(status, statusArray: StatusIdEnum[], pedido) {
        return statusArray.includes(status) && pedido.isCashbackCustomizado;
    }

    modal_observacoes_abrir(quotation_id, order_id, veiculo, fotos, pedido)
    {
        var tabActive = 3;

        if(pedido.notasFiscais.length > 0)
            tabActive = 2;

        if(fotos.length > 0)
            tabActive = 1;

        this.montarCotacaoSelecionada(quotation_id, order_id, veiculo, fotos, pedido.notasFiscais, tabActive, pedido.min_status, pedido.buyer_notes, pedido.seller_notes);

        this.pedidoSelecionado = pedido;

        let options: ModalOptions = { backdrop: 'static', class: 'gray modal-lg modal-fotos-nfs', keyboard: false };
        this.modalRef = this.modalService.show(this.templateObservacoes, options);
    }

    modal_fechar()
    {
        this.modalRef.hide();
        this.selectedOrder = null;
    }

    montarCotacaoSelecionada(quotation_id, order_id, veiculo, fotos, nfs, tabActive, min_status_id, buyer_notes, seller_notes)
    {
        let notasFiscais: NotaFiscal[] = nfs.map((nf) => { return { numero: nf.numero, url: nf.url, shipping_company_id: nf.shipping_company_id, shipping_company_name: nf.shipping_company_name, shipping_company_tracking_code: nf.shipping_company_tracking_code } });
        let notas_fiscais: PedidoNotaFiscal = { quotation_id: quotation_id, order_id: order_id, can_upload_nf: false, notasFiscais };

        this.cotacaoSelecionada = {
            active: tabActive,
            veiculo: veiculo,
            fotos: fotos,
            notas_fiscais: notas_fiscais,
            finalizada: isFinalStatus(min_status_id),
            buyer_notes,
            seller_notes
        };
    }

    onBlurDiscount(item: any) {
        if (!item.newDesconto || item.newDesconto < 0)
            item.newDesconto = 0;
    }

    openCancelarEntregaModal(order: any) {
        this.modalRef = this.modalService.show(this.templateCancelarEntrega, { backdrop: 'static', class: 'gray modal-lg', keyboard: false });

        this.ngxLoader.startLoader('loader-cancelar-entrega');
        this.isMercadoPartsfy = this.settingService.isMercadoPartsfy(this.agrupamento?.veiculo);

        this.dadosPedidoService.getRejectOrderReasons(CancelReasonRelatedId.PecaRejeitadaPeloComprador).subscribe({
            next: (response: ApiResponseModel<BuyerDashboardGetRejectOrderReasons>) => {
                if (response && response.success) {
                    this.cancelReasons = response.result.cancelReasons;
                    this.selectedOrder = order;

                    setTimeout(() =>
                    {
                        $('textarea[name="comment"]').val('');
                        this.excluirCotacaoNeedsComment = false;
                        $('select[name="reason"]')[0].selectedIndex = 0;

                    }, 200);

                    this.ngxLoader.stopLoader('loader-cancelar-entrega');
                }
            },
            error: error => {
                this.notificationService.showErrorToastr(this.globals.translate('buyer.dados-pedido.mensagens.erro.carregamento.corpo'));
                this.modal_fechar()
                this.ngxLoader.stopLoader('loader-cancelar-entrega');
            }
        })

    }

    openSellerWhatsapp(pedido: any) {
        this.generalService.whatsapp_abrir_conversa(pedido.seller_whatsapp);
    }

    salvarTransportadora($event: any)
    {
        const dadosTransportadora = {
            shipping_company_id: $event.shipping_company_id,
            shipping_company_name: $event.shipping_company_name,
            shipping_company_tracking_code: $event.shipping_company_tracking_code,
            nota_fiscal: $event.nota_fiscal
        }

        this.salvarTransportadoraExecucao($event.order_id, dadosTransportadora, 0);
    }

    salvarTransportadoraExecucao(orderId: number, dadosTransportadora: any, nAttempts: number)
    {
        this.curadorService.setShippingCompany(orderId, dadosTransportadora)
            .subscribe({
                next: () => {
                    this.notificationService.showSuccessToastr(this.globals.translate('componente.nota-fiscal.mensagens.sucesso.salvar-transportadora.corpo'));

                    const pedido = this.agrupamento.pedidos.find(p => p.order_id === orderId);

                    if (!pedido)
                        return;

                    const index = pedido.notasFiscais.findIndex(nf => nf.numero === dadosTransportadora.nota_fiscal);
                    let item = Object.assign({}, pedido.notasFiscais[index]);
                    item.shipping_company_id = dadosTransportadora.shipping_company_id;
                    item.shipping_company_name = dadosTransportadora.shipping_company_name;
                    item.shipping_company_tracking_code = dadosTransportadora.shipping_company_tracking_code;
                    pedido.notasFiscais.splice(index, 1, item);

                    this.montarCotacaoSelecionada(pedido.quotation_id, orderId, this.cotacaoSelecionada.veiculo, this.cotacaoSelecionada.fotos, pedido.notasFiscais, 2, this.cotacaoSelecionada.min_status_id, this.cotacaoSelecionada.seller_notes, this.cotacaoSelecionada.buyer_notes);
                },
                error: error => {
                    nAttempts = nAttempts || 1;
                    console.log(error, nAttempts);

                    if (nAttempts >= 5) {
                        this.notificationService.showErrorToastr(this.globals.translate('componente.nota-fiscal.mensagens.erro.salvar-transportadora.corpo'));
                        this.ngxLoader.stopLoader('loader-principal');
                        return;
                    }

                    this.salvarTransportadoraExecucao(orderId, dadosTransportadora, ++nAttempts);
                }
            });
    }

    selectAll($event, pedido)
    {
        if (isEmpty(pedido))
            return;

        var is_selected = $($event.target).is(":checked");

        if (!pedido.isOnReturnMode)
            pedido.pecas.filter(pe => pe.status >= StatusIdEnum.Pedido && !isFinalStatus(pe.status)).map(p => p.is_selected = is_selected);
        else
            pedido.pecas.filter(pe => pe.status === StatusIdEnum.Entregue).map(p => p.is_selected = is_selected);
    }

    setEditIsBO(item, pedido) {
        if(item.editIsBO) {
            item.data_entrega = ''
            item.showPF = false;
        } else {
            let hoje = new Date();
            hoje.setHours(3, 0, 0);

            item.data_entrega = { year: hoje.getFullYear(), month: hoje.getMonth() + 1, day: hoje.getDate() }
            var event = { year: hoje.getFullYear(), month: hoje.getMonth() + 1, day: hoje.getDate() }
            this.editDateChanged(event, item);
        }
    }

    setPickedUp(item, pedido) {
        const params: SweetAlertParams = {
            title: 'buyer.dados-pedido.confirmar-devolucao.titulo',
            message: 'buyer.dados-pedido.confirmar-devolucao.corpo',
            icon: 'warning',
            confirmButtonText: 'buyer.dados-pedido.confirmar-devolucao.botoes.sim',
            cancelButtonText: 'buyer.dados-pedido.confirmar-devolucao.botoes.nao',
        }

        this.notificationService.showConfirm(params).then((result) => {
            if (result.value)
            {
                this.ngxLoader.startLoader('loader-principal');
                this.dadosPedidoService.markItemAsSolved(item.item_id, pedido.order_id).subscribe({
                    next: (response: ApiResponseModel<boolean>) =>
                    {
                        if (response != null)
                        {
                            this.notificationService.showSuccessToastr(this.globals.translate('buyer.dados-pedido.mensagens.confirmar-devolucao.sucesso.corpo'));
                            this.atualizarPedido.emit({ quotation_id: pedido.transaction_id });
                        }

                        this.ngxLoader.stopLoader('loader-principal');
                    },
                    error: error =>
                    {
                        console.log(error);
                        this.ngxLoader.stopLoader('loader-principal');
                    }
                });
            }
        })
    }

    setSelectAll(pedido: any) {
        pedido.hasAguardandoConfirmacao = pedido.min_status < StatusIdEnum.Confirmado;
        pedido.showSelectAll = this.showSelectAll(pedido, false);
        pedido.showSelectAllColumn = this.showSelectAll(pedido, true);
    }

    setarPecaBO(item) {
        item.delivery_time.id = 99,
        item.delivery_time.day = null
        item.delivery_time.type = "BO",
        item.delivery_time.is_active = true
        item.delivery_time.type_name = "Back Order"
        item.delivery_time.day_formatado = "BO",
        item.delivery_time.prazo_formatado = "BO"
        item.delivery_time.prazo_formatado_com_tipo = "BO",
        item.delivery_time.is_PE = false,
        item.delivery_time.is_PF = false,
        item.delivery_time.is_BO = true
    }

    showAlgumaEntregaConfirmada(pedido): boolean
    {
        return pedido.pecas.filter(pe => pe.status === StatusIdEnum.Entregue).length > 0;
    }

    showSelectAll(pedido: any, ignorePickup: boolean)
    {
        if (isEmpty(pedido))
            return false;

        return pedido.pecas.filter(
                pe => pe.status >= StatusIdEnum.Pedido
                && !isFinalStatus(pe.status)
                && !isAwaitingConfirmationAfterDelivered(pe.status)
                && (ignorePickup || pe.status !== StatusIdEnum.AguardandoDevolucao)
            ).length > 0 || (pedido.isOnReturnMode && this.showAlgumaEntregaConfirmada(pedido));
    }

    showSendCrispMessage(pedido) {
        let showButton = !pedido.isOnReturnMode &&
                         this.origem_tipo === 'comprador' &&
                         this.userService.userIsCentral() &&
                         (pedido.min_status <= StatusIdEnum.EmAnalise ||
                          pedido.min_status == StatusIdEnum.AguardandoConfirmacaoTroca ||
                          pedido.min_status == StatusIdEnum.AguardandoConfirmacaoDevolucao);
        return showButton;
    }

    toggleDeliveryDateEdition(item: any, pedido: any) {
        if(item.lockDate || pedido.isOnEditMode || !item.can_change_delivery_date)
            return;

        const daysList = pedido.pecas.filter(p => p.delivery_day && p.delivery_day < 99).map(p => (p.delivery_day));

        if(pedido.pecas.every(p => p.delivery_day == 99)) {
            this.buyerService.handleEditItemsInfo(pedido, [], this.deliveryTimes, this.feriados);
            item.editDate = !item.editDate;
            item.newDataEntrega = item.data_entrega;

            this.itemCurrentlyEditing = item.editDate ? item : null;
            pedido.isOnEditMode = item.editDate;
            pedido.editionType = EditionTypeEnum.DeliveryDate;
            return;
        }

        this.generalService.getAllDeliveryDatesByWorkingDays(daysList).subscribe({
            next: (response: ApiResponseModel<{deliveryDates: { day: number, deliveryDate: Date }[]}>) => {
                this.buyerService.handleEditItemsInfo(pedido, response.result.deliveryDates, this.deliveryTimes, this.feriados);
                item.editDate = !item.editDate;
                item.newDataEntrega = item.data_entrega;

                this.itemCurrentlyEditing = item.editDate ? item : null;
                pedido.isOnEditMode = item.editDate;
                pedido.editionType = EditionTypeEnum.DeliveryDate;
            },
            error: error => {
                console.log(error);
            }
        });
    }

    toggleFreteEdition(pedido: any) {
        if(this.itemCurrentlyEditing != null)
            return;

        pedido.editFrete = !pedido.editFrete;
        pedido.newFrete = { valor: pedido.frete_valor, tipo: (pedido.frete_valor <= 0 && !pedido.buyer_responsability) ? 1 : 2, conta_comprador: pedido.buyer_responsability, was_changed: pedido.was_changed };
        pedido.isOnEditMode = pedido.editFrete;
        pedido.editionType = EditionTypeEnum.Frete;
    }

    toggleValueSectionEdition(item: any, pedido: any, shouldBlock: boolean) {
        if(shouldBlock || pedido.isOnEditMode)
            return;

        item.newQuantidade = item.quantidade;
        item.newValorUnitario = item.valor_unitario;
        item.newDesconto = item.desconto;
        item.editValueSection = !item.editValueSection

        this.itemCurrentlyEditing = item.editValueSection ? item : null;
        pedido.isOnEditMode = item.editValueSection;
        pedido.editionType = EditionTypeEnum.Values;
    }

    async trocarDevolverExecutar(pedido)
    {
        const inputOptions = {
            '1': this.globals.translate('buyer.dados-pedido.trocar-devolver.opcoes.voltar'),
            '2': this.globals.translate('buyer.dados-pedido.trocar-devolver.opcoes.trocar'),
            '3': this.globals.translate('buyer.dados-pedido.trocar-devolver.opcoes.devolver')
        };

        const params: SweetAlertParams = {
            title: 'buyer.dados-pedido.trocar-devolver.modal.titulo-1',
            input: 'radio',
            inputOptions: inputOptions,
            inputValidator: (value) => {
                if (!value)
                    return this.globals.translate('buyer.dados-pedido.trocar-devolver.modal.obrigatorio-1')
            }
        }

        const { value: opcao } = await this.notificationService.showConfirm(params);

        if (!isEmpty(opcao))
        {
            let listaItemIds = pedido.pecas.filter(p => p.is_selected && (p.status_id === StatusIdEnum.Entregue || p.status === StatusIdEnum.Entregue)).map(p => p.item_id);

            // Se a escolha foi somente voltar, chama a atualização de status
            if (opcao === '1')
            {
                this.trocarDevolverExecutarInterno(opcao, listaItemIds, pedido, null);
            }
            else // Se foi trocar ou devolver, deve avisar e pegar o motivo
            {
                let isTroca = opcao === '2';

                const paramsTroDev: SweetAlertParams = {
                    showDenyButton: !isTroca,
                    returnInputValueOnDeny: true,
                    confirmButtonText:  isTroca ? 'buyer.dados-pedido.trocar-devolver.modal.opcao-2.botao.trocar' : 'buyer.dados-pedido.trocar-devolver.modal.opcao-2.botao.devolver-so',
                    denyButtonText: 'buyer.dados-pedido.trocar-devolver.modal.opcao-2.botao.devolver-reabrir',
                    title: isTroca ? 'buyer.dados-pedido.trocar-devolver.modal.titulo-2.troca' : 'buyer.dados-pedido.trocar-devolver.modal.titulo-2.devolucao',
                    input: 'textarea',
                    footer: '<div class="row"><i class="fa fa-exclamation-triangle text-danger"></i> <label>' + this.globals.translate('buyer.dados-pedido.trocar-devolver.modal.footer-2') + '</label></div>',
                    inputValidator: (value) => {
                        if (!value)
                            return this.globals.translate('buyer.dados-pedido.trocar-devolver.modal.obrigatorio-2')
                    }
                }

                await this.notificationService.showConfirm(paramsTroDev).then((result) => {
                    let motivo = $('.swal2-textarea').val();

                    if (result.isDismissed || isEmpty(motivo))
                        return;

                    let op = (result.isDenied) ? '4' : opcao;

                    this.trocarDevolverExecutarInterno(op, listaItemIds, pedido, motivo);
                });
            }
        }
        else
            this.trocarDevolverVoltar(pedido);
    }

    private trocarDevolverExecutarInterno(opcao, listaItemIds, pedido, motivo)
    {
        this.ngxLoader.startLoader('loader-principal');
        this.dadosPedidoService.trocarDevolver(opcao, pedido.order_id, listaItemIds, motivo).subscribe({
            next: (response: ApiResponseModel<boolean>) =>
            {
                if (response != null && response.success)
                {
                    this.notificationService.showSuccessToastr(this.globals.translate('buyer.dados-pedido.trocar-devolver.mensagens.sucesso.corpo'));
                    this.atualizarPedido.emit({ quotation_id: pedido.transaction_id });
                }

                this.trocarDevolverVoltar(pedido);
                this.ngxLoader.stopLoader('loader-principal');
            },
            error: error =>
            {
                this.notificationService.showErrorToastr(this.globals.translate('buyer.dados-pedido.trocar-devolver.mensagens.erro.corpo'));
                console.log(error);
                this.ngxLoader.stopLoader('loader-principal');
            }
        });
    }

    trocarDevolverHabilitar(pedido) {
        this.unSelectAll(pedido.quotation_id);
        pedido.isOnReturnMode = true;
        this.setSelectAll(pedido);
    }

    trocarDevolverIsEnabled(pedido)
    {
        return pedido.pecas.some(i => (i.is_selected && i.status === StatusIdEnum.Entregue));
    }

    trocarDevolverVoltar(pedido) {
        this.unSelectAll(pedido.quotation_id);
        pedido.isOnReturnMode = false;
        this.setSelectAll(pedido);
    }

    limitQuantityInput(item: any, event: Event) {
        let inputElement = event.target as HTMLInputElement;
        let maxValue = Number(inputElement.max);
        let maxLength = inputElement.maxLength;
        let value = Number(inputElement.value);

        if (value > maxValue) {
            value = maxValue;
        }

        if (inputElement.value.length > maxLength) {
            value = Number(inputElement.value.slice(0, maxLength));
        }

        inputElement.value = value.toString();
        item.newQuantidade = value;
    }

    unSelectAll(quotation_id: number) {
        var inputSelectAll = $('.pedido_' + quotation_id).find('input');

        if (inputSelectAll.is(':checked'))
            inputSelectAll.trigger('click');

        const pedido = this.agrupamento.pedidos.find(p => p.quotation_id === quotation_id);
        pedido.pecas.forEach(i => i.is_selected = false);
    }

    whatsapp_enviar(pedido) {
        const companyName = this.userService.user()?.selectedUser?.current_company_name;

        let urlPartsfy = this.generalService.getPartsfyUrl();
        let urlCotacao = urlPartsfy + '/vendedor/visao-geral/confirmar-pedido/' + pedido.order_id;
        let oficina = companyName;
        let veiculo = pedido.marca + ' - ' + this.agrupamento.veiculo;
        let whatsapp = pedido.seller_whatsapp;
        let vendedor_email = pedido.seller_email;
        let vendedor_id = pedido.seller_id;
        let min_status = pedido.min_status;

        let whatsapp_message: WhatsAppMessage = {
            is_from_support: false,
            chassi: '',
            oficina: oficina,
            urlPartsfy: urlPartsfy,
            urlCTA: urlCotacao,
            veiculo: veiculo,
            vendedor_whatsapp: whatsapp,
            vendedor_id,
            vendedor_email,
            min_status: min_status
         };

        this.generalService.whatsapp_enviar_aguardando_confirmacao(whatsapp_message, 0);
    }

    zoomImage(imageSrc) {
        this.imageDisplayService.setImage(imageSrc);
    }
}
